import React from "react";

const Hero = () => {
  return (
    <div className="hero-gradient relative overflow-hidden flex flex-col justify-center items-center w-full">
      <img
        src="/assets/images/banners/cover.webp"
        alt=""
        fetchpriority="high"
        loading="eager"
        width="1920"
        height="1076"
        className="absolute inset-0 w-full h-full object-cover z-0"
      />
      <div className="relative z-10 max-w-screen-xl flex flex-col items-center w-full pt-3 pb-6 md:mb-10 px-4 sm:px-6 xl:px-0">
        {/* <div className="floating-mesh">
        <img
          src="/assets/images/banners/mesh.png"
          alt=""
          className="h-[400px]"
        />
      </div> */}

        <div className="flex flex-col md:flex-row w-full h-full relative z-10 justify-between items-center text-white">
          <div className="flex flex-col gap-9 h-full w-full lg:w-auto lg:mt-[72px] px-9 lg:px-0 relative z-10 pt-4 md:pt-0">
            <p className="text-5xl lg:text-8xl lg:max-w-[40vw] sm:max-w-[50vw] max-w-[70vw] ">
              Bringing Shine to Every Surface, Every Time
            </p>
            <p className="text-xl lg:text-2xl lg:max-w-[35vw] sm:max-w-[50vw] max-w-[80vw]">
              Trust our company in Melbourne for top-notch cleaning services
              that are guaranteed to meet your expectations.
            </p>

            <div className="md:flex items-center gap-6 hidden ">
              <a
                className="text-md w-[160px] h-[48px] flex items-center justify-center text-blue-5 border-2 border-white bg-white hover:bg-neutral-0 hover:border-neutral-0 hover:text-sm transition-all rounded "
                href="tel:+61404509680"
              >
                Call Now
              </a>
              {/* <NavLink
                className="text-md w-[160px] h-[48px] flex items-center justify-center text-white border-2 border-white hover:border-neutral-0 hover:text-sm transition-all rounded"
                to="/contact"
              >
                Inquire Now
              </NavLink> */}
            </div>
          </div>

          <div className="flex md:h-[80vh] items-start md:py-[80px] py-[40px]">
            <img
              src="/assets/images/banners/discount.webp"
              alt="discount banner"
              width="928"
              height="488"
              className="w-[300px] md:w-[458px] h-auto align-top"
            />
          </div>

          <div className="flex items-center gap-6 md:hidden pb-4">
            <a
              className="text-md w-[160px] h-[48px] flex items-center justify-center text-blue-5 border-2 border-white bg-white hover:bg-neutral-0 hover:border-neutral-0 hover:text-sm transition-all rounded "
              href="tel:+61404509680"
            >
              Call Now
            </a>
            {/* <a
              className="text-md w-[160px] h-[48px] flex items-center justify-center text-white border-2 border-white hover:border-neutral-0 hover:text-sm transition-all rounded"
              href="/contact"
            >
              Inquire Now
            </a> */}
          </div>

          {/* <img
          src="/assets/images/banners/hero.png"
          alt=""
          className="lg:h-[550px] h-[300px] md:h-[350px] hidden sm:block absolute top-[10%] md:relative right-0 z-0 md:right-auto md:top-auto"
        /> */}
        </div>
      </div>
    </div>
  );
};

export default Hero;
